<template>
  <v-container fill-height v-if="localLoading">
    <v-row align="center" justify="center">
      <v-col cols="12" align="center">
        <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
        <div class="text-h5 mt-4">Cargando información...</div>
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else-if="preaspirante && dictamen">
    <v-row>
      <v-col cols="12">
        <v-btn @click="$router.go(-1)" text color="secondary">
          <v-icon left>mdi-arrow-left</v-icon>
          Volver al catálogo
        </v-btn>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="8">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="font-weight-bold justify-center ui-module-titlebar">Registro de resultado en consulta previa</v-card-title>
          <v-card-text v-if="dictamen.length > 0">
            <v-form v-model="dictamenForm">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :value="getFullName(preaspirante)"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Aspirante"
                      :rules="nameRules"
                      readonly
                    ></v-text-field>
                    <v-text-field
                      v-model="dictamen[dictamen.length - 1].afis"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Afis"
                      :rules="nameRules"
                    ></v-text-field>
                    <v-text-field
                      v-model="dictamen[dictamen.length - 1].suic"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Suic"
                      :rules="nameRules"
                    ></v-text-field>
                    <v-text-field
                      v-model="dictamen[dictamen.length - 1].rnsp"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Rnsp"
                      :rules="nameRules"
                    ></v-text-field>
                    <v-select
                      label="Tipo de resultado"
                      v-model="dictamen[dictamen.length - 1].fk_idCatAlerta"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      item-color="secondary"
                      :items="alertas"
                      item-value="id"
                      item-text="alerta"
                    ></v-select>
                    <v-textarea
                      v-model="dictamen[dictamen.length - 1].resultadoConsultaPrevia"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Resultado en consulta previa"
                      no-resize
                      rows="8"
                      :rules="nameRules"
                    ></v-textarea>
                    <v-text-field
                      v-model="dictamen[dictamen.length - 1].oficio"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Número de oficio"
                      :rules="nameRules"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-text v-else>
            <div class="text-h6 text--primary">No se ha agendado cita de registro.</div>
          </v-card-text>
          <v-card-actions class="justify-center pb-6 ui-module-actions">
            <v-btn
              color="secondary"
              class="px-8 ui-module-btn-solid"
              :disabled="!dictamenForm || loading"
              v-on:click="triggerSaveTrainer()"
              >Registrar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  props: {
    id: {
      type: Number,
    },
  },

  async mounted() {
    this.localLoading = true
    this.SET_PREASPIRANTE_PARA_VALIDACION(this.id)

    if (!this.preaspirante) {
      this.isPersonal = true
      try {
        await this.fetchPersonalById(this.id)
        if (this.personalSingle) {
          this.SET_PREASPIRANTE_PARA_VALIDACION_DIRECT(this.personalSingle)
        } else {
          this.SET_SNACKBAR_MESSAGE('No se pudo encontrar la información del personal.')
        }
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Error al obtener la información del personal.')
      }
    }

    try {
      await this.fetchDictamenPersonal(this.id)

      if (this.isPersonal && this.dictamen.length === 0) {
        try {
          await this.saveDictamenPersonal({
            fk_idPersonal: this.id,
            resultadoConsultaPrevia: '',
            oficio: '',
            afis: '',
            suic: '',
            rnsp: '',
          })
          await this.fetchDictamenPersonal(this.id)
        } catch (error) {
          this.SET_SNACKBAR_MESSAGE('Error al inicializar el registro de consulta previa.')
        }
      }
    } catch (error) {
      this.SET_SNACKBAR_MESSAGE('Error al obtener el dictamen del personal.')
    }

    this.localLoading = false
  },

  data() {
    return {
      loading: false,
      localLoading: false,
      isPersonal: false,
      dictamenForm: false,
      menu: false,
      file: null,

      nameRules: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  computed: {
    ...mapGetters('preaspirante', {
      preaspirante: 'getPreaspiranteParaValidacion',
    }),

    ...mapGetters('personal', {
      personalSingle: 'getPersonalSingle',
    }),

    ...mapGetters('dictamenPersonal', {
      dictamen: 'getDictamenPersonal',
    }),

    ...mapGetters('alerta', {
      alertas: 'getAlertas',
    }),
  },

  methods: {
    ...mapActions('dictamenPersonal', ['updateDictamenPersonal', 'fetchDictamenPersonal', 'saveDictamenPersonal']),
    ...mapActions('preaspirante', ['fetchPreaspirantes']),
    ...mapActions('personal', ['fetchPersonalById']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapMutations('preaspirante', ['SET_PREASPIRANTE_PARA_VALIDACION', 'SET_PREASPIRANTE_PARA_VALIDACION_DIRECT']),

    triggerSaveTrainer: async function () {
      this.loading = true

      try {
        await this.updateDictamenPersonal(this.dictamen[this.dictamen.length - 1])

        if (this.isPersonal) {
          this.loading = false
          this.$router.push({ name: 'personalPersonal' })
        } else {
          await this.fetchPreaspirantes()
          this.loading = false
          this.$router.push({ name: 'Preaspirantes' })
        }
      } catch (error) {
        this.loading = false
        this.SET_SNACKBAR_MESSAGE('Error al guardar el dictamen.')
      }
    },

    saveBirthdayDate: function (date) {
      this.$refs.menu.save(date)
    },
  },
}
</script>

